// 国际篮联女子亚洲杯 顶部菜单

module.exports = {
  sportType: 'basketball',
  menuData: [
    {
      name: 'webMenu',
      arr: [
        // {
        //   name: '概述',
        //   key: 'summary',
        //   act: true,
        // },
        {
          name: '赛程',
          key: 'schedule',
          routeName: 'scheduleIndex_FIBAWA',
          act: true,
        },
        {
          name: '球队',
          key: 'team',
          routeName: 'teamIndex_FIBAWA',
          act: false,
        },
        {
          name: '球员',
          key: 'player',
          routeName: 'playerIndex_FIBAWA',
          act: false,
        },
        {
          name: '积分榜',
          key: 'leagueTable',
          routeName: 'leagueTableIndex_FIBAWA',
          act: false,
        },
        {
          name: '淘汰赛',
          key: 'knockoutRounds',
          routeName: 'knockoutRoundsIndex_FIBAWA',
          act: false,
        },
        {
          name: '数据中心',
          key: 'record',
          routeName: 'recordDetailIndex_FIBAWA',
          act: false,
          child: [
            {
              name: '数据概览',
              key: 'dataOverview',
              act: false,
              routeName: 'recordDetailDataOverview_FIBAWA',
            },
            {
              name: '球队数据',
              key: 'teamData',
              act: false,
              routeName: 'recordDetailTeamData_FIBAWA',
            },
            {
              name: '球员数据',
              key: 'playerData',
              act: false,
              routeName: 'recordDetailPlayerData_FIBAWA',
            },
            // {
            //   name: '阵容数据',
            //   key: 'lineupData',
            //   act: false,
            //   routeName: 'recordDetailLineupData_FIBAWA',
            // },
          ],
        },
      ],
    },
    {
      name: 'openMenu',
      arr: [
        {
          name: '节目单',
          key: 'programList',
          routeName: 'programListIndex_FIBAWA',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '播出单',
          key: 'broadcastList',
          routeName: 'broadcastListIndex_FIBAWA',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '数据包装',
          key: 'dataPackagList',
          routeName: 'dataPackagListIndex_FIBAWA',
          act: false,
          isOpenWeb: true,
        },
        // {
        //   name: 'H5组件',
        //   key: 'h5Comp',
        //   routeName: 'h5CompIndex_FIBAWA',
        //   act: false,
        // },
        // {
        //   name: 'API',
        //   key: 'openApi',
        //   routeName: 'openApiIndex_FIBAWA',
        //   act: false,
        // },
      ],
    },
  ],
}
